export default __webpack_public_path__ + "static/media/pyc.12d153e8.png";